export const SPONSORED_ADS_PROVIDER_IDS = {
  BING: {
    id: 111,
    name: "bing"
  },
  GOOGLE: {
    id: 112,
    name: "googleCustomAd"
  },
  YAHOO_SYNDICATION: {
    id: 113,
    name: "yahooSyndication"
  }
};

export const PORTAL_HOMEPAGE_AVAILABLE_TEMPLATES = { Template_2: "2", Template_3: "3", Template_4: "4", Template_5: "5" };
